













































import {defineComponent} from '@vue/composition-api';
import DynamicQuestionMixin from '@/tasks/mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import STextarea from '@/common/components/STextarea.vue';

export default defineComponent({
  name: 'UCIrvineELN1v2DataAnalysis3',
  components: {STextarea, StembleLatex},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        dataAnalysis3Calculations: null,
      },
      attachments: [] as File[],
      questions: [
        {
          text: 'Any written calculations may be included below.',
          inputName: 'dataAnalysis3Calculations',
        },
      ],
    };
  },
});
